export enum ThumbDetails {
  YOUTUBE = 'YOUTUBE',
  VIMEO = 'VIMEO',
  WARNING = 'WARNING',
  LOADING = 'LOADING',
}
